import dayjs from "dayjs";

  class CoffeeHome extends HTMLElement {

    // ── A. Shadow DOM + state ────────────────────────────────────────────
    constructor() {
      super();
      this._shadow  = this.attachShadow({ mode: "open" });
      this._data    = null;

      // runtime state
      this._balance  = 0;
      this._drank    = 0;
      this._offered  = 0;
      this._marked   = 0;
      this._mode     = "icons";
      this._images   = {
        "drank": "data:image/webp;base64,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",
        "offered": "data:image/webp;base64,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", 
        "marked":  "data:image/webp;base64,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", 
      };
      this._pending  = []; // { id, type }
      this._nextId   = 1;
    }

    // ── B. Lifecycle ─────────────────────────────────────────────────────
    connectedCallback() {
      this._render();
      this._bindEvents();
    }

    // ── C. data property setter ──────────────────────────────────────────
    set data(obj) {
      this._data    = obj || {};
      this._balance = obj?.balance      ?? 0;
      this._drank   = obj?.drank_today  ?? 0;
      this._offered = obj?.offered_today ?? 0;
      this._marked  = obj?.marked_today ?? 0;      
      this._mode    = obj?.mode ?? "icons";
      if (obj.images) {
        this._images = obj.images;
      }
      this._pending = [];
      this._render();
      this._bindEvents();
    }

    set balance(val) {
      this._balance = val ;
      //this._renderCapsules()
      this._updateDynamic()
    }

    set images(obj) {
      this._images = obj;

      //this._updateDynamic()
      this._renderCapsules()
      this._renderActions()
    }

    set today(obj) {
      obj.forEach((cur) => {
        //console.log("Loading todays info: %o", cur);
        if (cur.type === "drink") {
          this._initPending("drank", cur);
        } else if (cur.type === "offer") {
          this._initPending("offered", cur);
        } else if (cur.type === "mark") {
          this._initPending("marked", cur);
        }
        
      });
      this._renderCapsules()
    }

    set updateCoffeId(obj) {
      console.log("Updating id of the new created coffee: %o", obj);

      const idx = this._pending.findIndex(p => p.id === obj.id);
      if (idx === -1) return;
      //const p = this._pending.splice(idx, 1)[0];

      this._pending[idx].key = obj.key;
      //this._updateDynamic();
    }

    // ── D. Attribute bridge ───────────────────────────────────────────────
    static get observedAttributes() { return ["data"]; }
    attributeChangedCallback(name, _, newVal) {
      if (name === "data") { try { this.data = JSON.parse(newVal); } catch {} }
    }

    // ── E. Helpers ────────────────────────────────────────────────────────
    _price()        { return this._data?.coffee_price ?? 0.80; }
    _iconDrank(clazz)    { 
      if (this._mode === "icons") { 
        return this._data?.icon_drank   ?? "☕";  
      } else {
        return `<img class="img-x ${clazz}" src="${this._images["drank"]}">`;
      }
    }
    _iconOffered(clazz)    { 
      if (this._mode === "icons") { 
        return this._data?.icon_offered   ?? "🫖";  
      } else {
        return `<img class="img-x ${clazz}" src="${this._images["offered"]}">`;
      }
    }
     _iconMarked(clazz)    { 
      if (this._mode === "icons") { 
        return this._data?.icon_marked   ?? "🥣";  
      } else {
        return `<img class="img-x ${clazz}" src="${this._images["marked"]}">`;
      }
    }

    
   
    

    _fmtBalance(v) {
      return v.toLocaleString("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    _fmtEquiv(bal) {
      const n = Math.round(bal / this._price());
      return "(equivalente a circa " + n.toLocaleString("it-CH") + " caffè)";
    }

    _initPending(type, coffee) {
      const id = this._nextId++;
      let el = { id, type };
      if (coffee.id) {
        el.key = coffee.id 
      }
      el.time = coffee.created_at.substring(11, 16);
      //console.log("el: %o", el);
      this._pending.push(el);
    }

    // ── F. Log a coffee ───────────────────────────────────────────────────
    _log(type) {
      const currentDate = dayjs();
      const time = currentDate.format('HH:mm');

      const id = this._nextId++;
      this._pending.push({ time: time, id, type });
      
      
      if (type === "drank") {
        this._drank++; 
        this._balance -= this._price();
      } else if (type === "offered") {
        this._offered++;
        this._balance -= this._price();
      } else {
        this._marked++;
      }

      this.dispatchEvent(new CustomEvent("coffee-log", {
        detail: { type, balance_after: this._balance, id },
        bubbles: true, composed: true,
      }));

      this._updateDynamic();
    }

    // ── G. Undo a pending coffee ──────────────────────────────────────────
    _undo(id) {
      const idx = this._pending.findIndex(p => p.id === id);
      if (idx === -1) return;
      const p = this._pending.splice(idx, 1)[0];
      
      if (p.type === "drank") {
        this._balance += this._price();
        this._drank--;
      } else if (p.type === "offered") {
        this._balance += this._price();
        this._offered--;
      } else {
        this._marked--;
      } 

      this.dispatchEvent(new CustomEvent("coffee-undo", {
        detail: { type: p.type, balance_after: this._balance, key: p.key, id },
        bubbles: true, composed: true,
      }));

      this._updateDynamic();
    }

    // ── I. Update only the dynamic regions (no full re-render) ────────────
    _updateDynamic() {
      const root = this._shadow;

      const balEl = root.getElementById("balance-val");
      if (balEl) balEl.innerHTML = this._fmtBalance(this._balance)
        + ' <span class="currency">CHF</span>';

      const eqEl = root.getElementById("equiv");
      if (eqEl) eqEl.textContent = this._fmtEquiv(this._balance);

      const drEl = root.getElementById("count-drank");
      if (drEl) drEl.textContent = this._drank;

      const ofEl = root.getElementById("count-offered");
      if (ofEl) ofEl.textContent = this._offered;

      const mkEl = root.getElementById("count-marked");
      if (mkEl) mkEl.textContent = this._marked;

      this._renderCapsules();
    }

    // ── J. Re-render only the pending capsules strip ──────────────────────
    _renderCapsules() {
      //console.log("🏠 Render capsuls");
      const wrap = this._shadow.getElementById("pending");
      let hint = this._shadow.getElementById("pending-hint");

      if (!wrap) return;

      if (!this._pending.length) {
        hint.innerHTML = 'Clicca un bottone per registrare un caffè';
      } else {
        hint.innerHTML = '';
      }

      wrap.innerHTML = this._pending.map(p => {
        let clazz = "capsule";
        let label = "";
        let aria = "Annulla caffè";
        let icon = "";

        if (p.time) {
          label = p.time;
        }

        if (p.type === "drank") {
          clazz = "capsule drank";
          aria = "Annulla caffè bevuto";
          icon = this._iconDrank("medium");
        } else if (p.type === "offered") {
          clazz = "capsule offered";
          aria = "Annulla caffè offerto";
          icon = this._iconOffered("medium");
        } else {
          clazz = "capsule marked";
          aria = "Annulla caffè marcato";
          icon = this._iconMarked("medium");
        }
        let version1 = `
        <div class="${clazz}"
             data-id="${p.id}" role="button" tabindex="0"
             aria-label="${label}">
          ${icon}
          ${label}
          <span class="capsule-x" aria-hidden="true">✕</span>
        </div>`;
        let version2 = `
        <div class="${clazz}"
             data-id="${p.id}" role="button" tabindex="0"
             aria-label="${label}">
          ${icon}
          <div class="time">${label}</div>
        </div>`;
        return version2;
      }).join("");

      // bind capsule click/keyboard
      wrap.querySelectorAll(".capsule").forEach(el => {
        el.addEventListener("click", () => this._undo(Number(el.dataset.id)));
        el.addEventListener("keydown", e => {
          if (e.key === "Enter" || e.key === " ") this._undo(Number(el.dataset.id));
        });
      });
    }

    // ── K. Bind button events ─────────────────────────────────────────────
    _bindEvents() {
      console.log("🏠 Bind events");
      const root = this._shadow;
      root.getElementById("btn-drank")?.addEventListener("click",   () => this._log("drank"));
      root.getElementById("btn-offered")?.addEventListener("click", () => this._log("offered"));
      root.getElementById("btn-marked")?.addEventListener("click", () => this._log("marked"));
    }

    _getActions() {
      const d     = this._data || {};
      const lDrank   = d.label_drank   || "Bevi";
      const lOffered = d.label_offered || "Offri";
      const lMarked = d.label_marked || "Marca";
      let actions = `
        <button class="btn btn-drank" id="btn-drank"
                aria-label="${lDrank} – registra un caffè bevuto">
          <span class="btn-icon">${this._iconDrank("big")}</span>
          <span class="btn-label">${lDrank}</span>
          <span style="display: none" class="btn-sub">Log a coffee</span>
        </button>
        <button class="btn btn-offered" id="btn-offered"
                aria-label="${lOffered} – registra un caffè offerto">
          <span class="btn-icon">${this._iconOffered("big")}</span>
          <span class="btn-label">${lOffered}</span>
          <span style="display: none" class="btn-sub">Offer one</span>
        </button>
        <button class="btn btn-marked" id="btn-marked"
                aria-label="${lMarked} – registra un caffè ricevuto">
          <span class="btn-icon">${this._iconMarked("big")}</span>
          <span class="btn-label">${lMarked}</span>
          <span style="display: none" class="btn-sub">Mark one</span>
        </button>
      `;

      return actions;
    }
    _renderActions() {
      console.log("🏠 Render actions");
      const container = this._shadow.getElementById("actions");
      container.innerHTML = this._getActions();
      this._bindEvents()
    }

    // ── L. Full render ────────────────────────────────────────────────────
    _render() {
      const d     = this._data || {};
      const user  = d.user || {};
      const src   = user.avatar || "";
      const name  = user.name   || "";
      const ver   = d.version   || "";
      const lBalance = d.label_balance || "Il tuo saldo";

      const avatarHTML = src
        ? `<img class="avatar" src="${src}" alt="${name}"
               onerror="this.style.display='none';this.nextElementSibling.style.display='flex'">
           <div class="avatar-ph" style="display:none">${name.slice(0,1)}</div>`
        : `<div class="avatar-ph">${name.slice(0,1)}</div>`;

      const actions =  this._getActions();

      this._shadow.innerHTML = `
        <style>
          
          *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

          :host {
            display: block;
            /*font-family: 'DM Sans', system-ui, sans-serif;*/
            height: 100%;
          }

          .shell {
            /*height: 100%;*/
            height: calc(100vh - 190px);
            display: flex;
            flex-direction: column;
            overflow: hidden;
            position: relative;
          
            background: #fff;
            border: 0.5px solid #e0dfd7;
            border-radius: 12px;
            /*padding: 1.25rem;*/
            padding: 0px;
            margin: 10px;
          }

          @media  (min-width: 601px) {
            .shell {
              height: calc(100vh - 100px);
            }
          }

          /* ── Body ── */
          .body {
            flex: 1;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            padding: 40px 24px 32px;
            display: flex;
            flex-direction: column;
          }

          /* ── Balance ── */
          .balance-section {
            text-align: center;
            margin-bottom: 36px;
            animation: fade-up 0.5s ease both;
          }

          .balance-label {
            /*font-family: 'DM Serif Display', serif;*/
            /*font-style: italic;*/
            font-size: 18px;
            color: #7a5540;
            margin-bottom: 8px;
          }

          .balance-val {
            /*font-family: 'DM Serif Display', serif;*/
            font-size: 54px;
            color: #2d1710;
            line-height: 1;
            letter-spacing: -2px;
            margin-bottom: 8px;
          }

          .currency {
            font-size: 28px;
            color: #7a5540;
            letter-spacing: 0;
          }

          .balance-equiv {
            font-size: 13px;
            color: #a07858;
            /*font-style: italic;*/
          }

          /* ── Stats cards ── */
          .stats {
            display: grid;
            /*
            display: flex;
            flex-direction: colum;
            */
            grid-template-columns: 1fr 1fr 1fr;
            gap: 12px;
            margin-bottom: 28px;
            animation: fade-up 0.5s 0.08s ease both;
          }

          .stat-card {
            background: #fff;
            border-radius: 18px;
            padding: 16px 18px;
            border: 0.5px solid rgba(74,44,26,0.1);
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .stat-icon   { font-size: 22px; margin-bottom: 2px; }
          .stat-val    { /*font-family: 'DM Serif Display', serif;*/ font-size: 32px; color: #2d1710; line-height: 1; }
          .stat-label  { font-size: 11px; color: #a07858; font-weight: 500; letter-spacing: 0.02em; }

          /* ── Pending capsules ── */
          .pending {
            min-height: 40px;
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(50px, 1fr) ) ;
            /*flex-wrap: wrap;*/
            row-gap: 2px;
            column-gap: 7px;
            align-items: center;
            margin-top: 24px;
            animation: fade-up 0.5s 0.14s ease both;
          }

          .pending-hint {
            font-size: 12px;
            color: #c8a882;
            /*font-style: italic;*/
          }

          .capsule {
            /*display: inline-flex;*/
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 6px;
            border-radius: 5px;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            transition: opacity 0.15s, transform 0.1s;
            animation: capsule-pop 0.25s cubic-bezier(0.34,1.56,0.64,1) both;
            user-select: none;
            -webkit-tap-highlight-color: transparent;
            background: transparent;
            /*
            min-width: 70px;
            padding: 7px 10px 7px 14px;*/
          }

          /*
          .capsule.drank {
            background: #4a2c1a;
            color: #f2ebe3;
            border: 2px solid #f2ebe3;
          }

          .capsule.offered {
            background: #f2ebe3;
            color: #4a2c1a;
            border: 2px solid #4a2c1a;
          }

          .capsule.marked {
            background: transparent;
            color: #4a2c1a;
            border: 2px solid #4a2c1a;
          }
          */

          .time {
            color: #5D4037;
            padding: 7px 3px 2px 3px;
            border-radius: 7px;
            font-size: 10px;
            margin-top: -14px;
          }

          .capsule:hover   { opacity: 0.82; }
          .capsule:active  { transform: scale(0.94); }
          .capsule:focus-visible { outline: 2px solid #4a2c1a; outline-offset: 2px; }

          .capsule-x {
            width: 18px; height: 18px;
            border-radius: 50%;
            background: rgba(242,235,227,0.22);
            display: flex; align-items: center; justify-content: center;
            font-size: 9px;
            flex-shrink: 0;
          }

          .img-x.small {
            max-width: 30px;
            max-height: 30px; 
          }

          .img-x.medium {
            max-width: 40px;
            max-height: 40px; 
          }

          .img-x.big {
            max-width: 50px;
            max-height: 50px; 
          }

          .capsule.offered .capsule-x { background: rgba(74,44,26,0.1); }

          /* ── Action buttons ── */
          .actions {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 12px;
            animation: fade-up 0.5s 0.2s ease both;
            margin-top: auto;
          }

          .btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 10px 10px;
            border-radius: 8px;
            border: none;
            cursor: pointer;
            /*font-family: 'DM Sans', system-ui, sans-serif;*/
            transition: transform 0.15s, opacity 0.15s;
            -webkit-tap-highlight-color: transparent;
            min-height: 120px;
          }

          @media (min-width: 601px) {
          .btn {
            display: flex;
            flex-direction: row;
            padding: 0px 0px;
            min-height: 50px;
          }
          .body {
            padding: 10px 10px 10px;
          }
          .balance-section {
            margin-bottom: 10px;
          }
          .pending {
            margin-top: 5px;
          }
          }

          .btn:active { transform: scale(0.95); }
          .btn:focus-visible { outline: 2px solid #4a2c1a; outline-offset: 3px; }

          .btn-drank {
            background: #4a2c1a;
            color: #f2ebe3;
          }

          .btn-offered {
            background: #f2ebe3;
            color: #4a2c1a;
            border: 2.5px solid #4a2c1a;
          }

          .btn-marked {
            background: transparent;
            color: #4a2c1a;
            border: 2.5px solid #4a2c1a;
          }

          .btn-icon  { font-size: 36px; line-height: 1; }

          .btn-label {
            /*font-family: 'DM Serif Display', serif;*/
            font-size: 22px;
            letter-spacing: -0.3px;
            line-height: 1;
          }

          .btn-sub   { font-size: 11px; opacity: 0.5; font-weight: 500; }

          @keyframes fade-up {
            from { opacity: 0; transform: translateY(14px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          @keyframes capsule-pop {
            from { opacity: 0; transform: scale(0.5); }
            to   { opacity: 1; transform: scale(1); }
          }
          @keyframes flash-anim {
            0%   { opacity: 0;   transform: translate(-50%,-50%) scale(0.4); }
            35%  { opacity: 1;   transform: translate(-50%,-50%) scale(1.25); }
            100% { opacity: 0;   transform: translate(-50%,-50%) scale(1.8); }
          }

          /* Dark mode */
          /*
          @media (prefers-color-scheme: dark) {
            .shell         { background: #1e110a; }
            .stat-card     { background: #2a1a10; border-color: rgba(242,235,227,0.08); }
            .stat-val      { color: #f2ebe3; }
            .balance-val   { color: #f2ebe3; }
            .btn-offered   { background: #2a1a10; color: #f2ebe3; border-color: rgba(242,235,227,0.4); }
            .capsule.offered { color: #f2ebe3; border-color: rgba(242,235,227,0.5); }
          }
          */
        </style>

        <div class="shell">
          <div class="body">

            <div class="balance-section">
              <div class="balance-label">${lBalance}</div>
              <div class="balance-val" id="balance-val">
                ${this._fmtBalance(this._balance)} <span class="currency">CHF</span>
              </div>
              <div class="balance-equiv" id="equiv">${this._fmtEquiv(this._balance)}</div>
            </div>

           
            <div class="pending" id="pending">
              
            </div>
            <span style="display: none;" id="pending-hint" class="pending-hint">Clicca un bottone per registrare un caffè</span>

            <div id= "actions" class="actions">
            
              ${actions}
            </div>

            

          </div>
        </div>
      `;
    }
  }

export { CoffeeHome }
